import PropTypes from 'prop-types';
import React from 'react';
import EditModal from '../../common/modal/EditModal';
import { PaymentsInsuranceForm } from './PaymentsInsuranceForm';
export var AddInsurance = function AddInsurance(_ref) {
  var contactId = _ref.contactId;
  return /*#__PURE__*/React.createElement(EditModal, {
    header: "Add Insurance Information",
    id: "add-insurance-modal",
    size: "normal",
    showEdit: false,
    showAdd: true,
    addButtonId: "add-insurance-button",
    addLabelText: "Add Insurance"
  }, /*#__PURE__*/React.createElement(PaymentsInsuranceForm, {
    contactId: contactId
  }));
};
AddInsurance.propTypes = {
  contactId: PropTypes.string.isRequired
};
//# sourceMappingURL=AddInsurance.js.map